/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    Form,
    Switch,
    Button,
    DatePicker,
    Input,
    Select,
    Space,
    Radio,
} from 'antd';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import RiskRegisterService from '../../../services/RiskRegister.service';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import likeliHoodImpact from '../../../assets/Images/svg/likeliHood/likelihood-impact-img.svg';
import Moment from 'moment';
import useNotify from '../../../context/Notification/useNotify';
import { useBlocker } from '../../../util/usePrompt';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';

export default function RiskRegisterFormEdit({ detail, setDetail }) {
    const [form] = Form.useForm();
    const { riskId } = useParams();
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { RangePicker } = DatePicker;
    const { TextArea } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { mode, options, subOption } = location?.state;

    const [impactType, setImpactType] = useState([]);
    const [impactLevel, setImpactLevel] = useState([]);
    const [likelihood, setLikelihood] = useState([]);
    const [impactScore, setImpactScore] = useState();
    const [haveImpactType, setHaveImpactType] = useState(true);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const acceptTheRisk = Form.useWatch('acceptTheRisk', form);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();
    const notify = useNotify();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search,
            { state: { mode } }
        );
    };

    useEffect(() => {
        const getImpactType = async (riskAssessmentId) => {
            const { data } = await RiskRegisterService.getImpactType(
                riskAssessmentId
            );
            if (data.resultData) {
                setImpactType(data.resultData);
            }
        };
        const getLikelihood = async (riskAssessmentId) => {
            const { data } = await RiskRegisterService.getLikelihood(
                riskAssessmentId
            );
            if (data.resultData) {
                setLikelihood(data.resultData);
            }
        };
        const getRiskAssessmentHeader = async () => {
            try {
                const { data } = await RiskAssessmentService.getRiskListTab(
                    riskId
                );
                if (data?.resultData) {
                    const item = data?.resultData;
                    await getImpactType(item?.riskAssessmentId);
                    await getLikelihood(item?.riskAssessmentId);
                    await getDetail();
                }
            } catch (err) {
                console.log(err);
            }
        };
        getRiskAssessmentHeader();
    }, [detail]);

    const getDetail = async () => {
        if (detail && (subOption?.id || options?.id)) {
            setValue(detail.acceptTheRisk);
            getImpactLevel(detail.impactTypeId);
            getImpactScore(detail?.impactLevelId, detail?.likelihoodId);
            setHaveImpactType(false);
            await form.setFieldsValue({
                causes: detail.causes,
                consequence: detail.consequence,
                workInstruction: detail.workInstruction || null,
                impactTypeId: detail.impactTypeId,
                impactLevelId: detail.impactLevelId,
                likelihoodId: detail.likelihoodId,
                acceptTheRisk: detail.acceptTheRisk,
                confirmToUse: detail.confirmToUse,
            });
            if (detail.acceptTheRisk === false) {
                setShow(true);
                const datePlan = [];
                if (detail.startDate && detail.endDate) {
                    datePlan.push(Moment(detail.startDate));
                    datePlan.push(Moment(detail.endDate));
                }

                await form.setFieldsValue({
                    todo: detail.todo || null,
                    datePlan: datePlan,
                });
            }
            await setImpactScore({
                riskScoreId: detail.riskScoreId,
                score: detail.score,
                riskLevelNameEn: detail.riskLevelNameEn,
                riskLevelNameTh: detail.riskLevelNameTh,
                riskLevelColor: detail.riskLevelColor,
            });
        }
    };
    const getImpactLevel = async (ImpactTypeTopicId) => {
        const { data } = await RiskRegisterService.getImpactLevel(
            ImpactTypeTopicId
        );
        if (data.resultData) {
            setImpactLevel(data.resultData);
        }
    };
    const getImpactScore = async (impactLevelId, likelihoodLevelId) => {
        try {
            const { data } = await RiskRegisterService.getImpactScore({
                impactLevelId: impactLevelId,
                likelihoodLevelId: likelihoodLevelId,
            });
            if (data?.resultCode === 1) {
                setImpactScore(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const onImpactTypeChange = (value) => {
        setHaveImpactType(false);
        form.setFieldsValue({ impactLevelId: null, likelihoodId: null });
        getImpactLevel(value);
        setImpactScore();
    };
    const onImpactLevelChange = (value) => {
        form.setFieldsValue({ likelihoodId: null });
        setImpactScore();
    };
    const onLikelihoodChange = (value) => {
        getImpactScore(form.getFieldValue('impactLevelId'), value);
    };

    const [value, setValue] = useState(null);
    const [show, setShow] = useState(false);

    const onChange = (e) => {
        setValue(e.target.value);
        if (e.target.value === true)
            form.setFieldsValue({ datePlan: null, todo: null });
        setShow(false);
        if (e.target.value === false) setShow(true);
    };
    const onFinish = async (value) => {
        if (detail?.id) {
            const payload = {
                id: detail?.id,
                riskRegisterId: riskId,
                riskFactorOptionId: options?.riskFactorOptionId || null,
                riskFactorSubOptionId: subOption?.riskFactorSubOptionId || null,
                causes: value.causes || null,
                consequence: value.consequence || null,
                workInstruction: value.workInstruction || null,
                impactTypeId: value.impactTypeId,
                impactLevelId: value.impactLevelId,
                likelihoodId: value.likelihoodId,
                riskScoreId: impactScore.riskScoreId,
                acceptTheRisk: value.acceptTheRisk ?? false,
                todo: value.todo || null,
                startDate: value.datePlan
                    ? Moment(new Date(value.datePlan[0])).format()
                    : null,
                endDate: value.datePlan
                    ? Moment(new Date(value.datePlan[1])).format()
                    : null,
                confirmToUse: value.confirmToUse,
            };
            try {
                const { data } =
                    await RiskRegisterService.updateRiskRegisterDetail(payload);
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    setChange(false);
                    navigate(-1, { state: { mode } });
                    setDetail();
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            } catch (error) {
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } else {
            const payload = {
                id: null,
                riskRegisterId: riskId,
                riskFactorOptionId: options?.riskFactorOptionId || null,
                riskFactorSubOptionId: subOption?.riskFactorSubOptionId || null,
                causes: value.causes || null,
                consequence: value.consequence || null,
                workInstruction: value.workInstruction || null,
                impactTypeId: value.impactTypeId,
                impactLevelId: value.impactLevelId,
                likelihoodId: value.likelihoodId,
                riskScoreId: impactScore.riskScoreId,
                acceptTheRisk: value.acceptTheRisk ?? false,
                todo: value.todo || null,
                startDate: value.datePlan
                    ? Moment(new Date(value.datePlan[0])).format()
                    : null,
                endDate: value.datePlan
                    ? Moment(new Date(value.datePlan[1])).format()
                    : null,
                confirmToUse: value.confirmToUse,
            };
            try {
                const { data } =
                    await RiskRegisterService.createRiskRegisterDetail(payload);
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    setChange(false);
                    navigate(-1, { state: { mode } });
                    setDetail();
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            } catch (error) {
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        }
    };

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
                initialValues={{ confirmToUse: true }}
                //   ,acceptTheRisk:1
            >
                <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
                    <div
                        className="flex justify-between "
                        style={{ borderBottom: '3px solid #F4F6FC' }}
                    >
                        <div className="text-2xl font-semibold pb-2 text-purple">
                            {t('RR.RiskFactors')} :{' '}
                            {subOption?.riskFactorSubOptionName
                                ? subOption?.riskFactorSubOptionName
                                : options?.riskFactorOptionName || '-'}
                        </div>
                        <div className="space-x-3 font-sm items-right justify-end">
                            <div className="flex space-x-2">
                                <div>
                                    {t('RR.ConfirmData')} {` `}{' '}
                                </div>
                                <div>
                                    <Form.Item
                                        name="confirmToUse"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="space-x-4 items-right mb-2 text-right">
                                <Button
                                    size="large"
                                    type="default"
                                    className="text-purple-PHX border-purple-PHX w-32"
                                    onClick={() => {
                                        form.resetFields();
                                        setValue();
                                        setImpactScore();
                                        setShow(false);
                                    }}
                                >
                                    {t('RR.ClearData')}
                                </Button>
                                <Button
                                    size="large"
                                    type="primary"
                                    className="w-32"
                                    htmlType="submit"
                                >
                                    {t('common.Save')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="p-2">
                        <div className="grid grid-cols-3">
                            <div className="col-span-2 my-1 mr-4">
                                <Form.Item
                                    name={'causes'}
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.Cause')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <TextArea
                                        size="large"
                                        className="bg-[#F4F6FC]"
                                        autoSize={{ minRows: 4, maxRows: 6 }}
                                        placeholder={t('dataFlow.inputpl')}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name={'consequence'}
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.Consequence')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <TextArea
                                        size="large"
                                        className="bg-[#F4F6FC]"
                                        autoSize={{ minRows: 4, maxRows: 6 }}
                                        placeholder={t('dataFlow.inputpl')}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name={'workInstruction'}
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.ProcedureOrWorkInstruction')}
                                        </span>
                                    }
                                >
                                    <TextArea
                                        size="large"
                                        className="bg-[#F4F6FC]"
                                        autoSize={{ minRows: 4, maxRows: 6 }}
                                        placeholder={t('dataFlow.inputpl')}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="impactTypeId"
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.TypeOfImpact')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('RR.SelectTypeOfImpact')}
                                        onChange={onImpactTypeChange}
                                    >
                                        {impactType.map((e) => {
                                            return (
                                                <Select
                                                    key={e.impactTypeId}
                                                    value={e.impactTypeId}
                                                >
                                                    {e.name}
                                                </Select>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="impactLevelId"
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.ImpactLevel')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        disabled={haveImpactType}
                                        placeholder={t('RR.SelectImpactLevel')}
                                        onChange={onImpactLevelChange}
                                    >
                                        {impactLevel.map((e) => {
                                            return (
                                                <Select
                                                    key={e.impactLevelId}
                                                    value={e.impactLevelId}
                                                >
                                                    {e.name}
                                                </Select>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="likelihoodId"
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.Likelihood')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        // disabled={true}
                                        placeholder={t('RR.SelectLikelihood')}
                                        onChange={onLikelihoodChange}
                                    >
                                        {likelihood.map((e) => {
                                            return (
                                                <Select
                                                    key={e.riskMapLevelId}
                                                    value={e.riskMapLevelId}
                                                >
                                                    {e.name}
                                                </Select>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                                {impactScore && (
                                    <div
                                        className={`p-3 rounded-md`}
                                        style={{
                                            background:
                                                impactScore?.riskLevelColor,
                                        }}
                                    >
                                        <div className="text-sm text-white">
                                            {t('RR.ResultingRiskScore')}
                                        </div>
                                        <div className="text-base font-semibold text-white">
                                            {impactScore?.score} :{' '}
                                            {lang === 'en'
                                                ? impactScore?.riskLevelNameEn
                                                : impactScore?.riskLevelNameTh}{' '}
                                        </div>
                                    </div>
                                )}
                                <div className="mt-5 mb-5">
                                    <img
                                        src={likeliHoodImpact}
                                        alt="LikeliHood Impact"
                                    />
                                </div>
                                <Form.Item
                                    name="acceptTheRisk"
                                    label={
                                        <span className="text-[20px] font-bold">
                                            {t('RR.WillYouAcceptRisk')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Radio.Group
                                        onChange={onChange}
                                        value={value}
                                    >
                                        <Space>
                                            <Radio
                                                className={
                                                    value === true
                                                        ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                        : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                                }
                                                key={1}
                                                value={true}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {t('RR.AcceptRisk')}
                                            </Radio>
                                            <Radio
                                                className={
                                                    value === false
                                                        ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                        : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                                }
                                                key={2}
                                                value={false}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {t('RR.NotAcceptRisk')}
                                            </Radio>
                                        </Space>
                                    </Radio.Group>
                                </Form.Item>
                                {acceptTheRisk && impactScore?.score >= 15 && (
                                    <span className="ant-form-item-explain-error">
                                        {parse(
                                            t(
                                                'The risk assessment results are high or very high'
                                            )
                                        )}
                                    </span>
                                )}
                                {show === true && (
                                    <>
                                        <Form.Item
                                            name={'todo'}
                                            label={
                                                <span className="text-[20px] font-bold">
                                                    {t('RR.Todo')}
                                                </span>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <TextArea
                                                size="large"
                                                className="bg-[#F4F6FC]"
                                                autoSize={{
                                                    minRows: 4,
                                                    maxRows: 6,
                                                }}
                                                placeholder={t(
                                                    'dataFlow.inputpl'
                                                )}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name={'datePlan'}
                                            label={
                                                <span className="text-[20px] font-bold">
                                                    {t('RR.DatePlan')}
                                                </span>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <RangePicker
                                                size="large"
                                                placeholder={[
                                                    t('Start date'),
                                                    t('End date'),
                                                ]}
                                                style={{
                                                    width: '100%',
                                                }}
                                                format="DD/MM/YYYY"
                                            />
                                        </Form.Item>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </>
    );
}
